import { CREATE_SKILL, REMOVE_SKILL } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";
export const skills = (state=loadFromLocalStorage(CREATE_SKILL, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_SKILL:{
            const {skill} = payload;
            const newSkill = {
                skill,
            };
            const updatedState = state.concat(newSkill);
            saveToLocalStorage(CREATE_SKILL, updatedState);
            return updatedState;
        }
        case REMOVE_SKILL: {
            const {skill} = payload;
            const updatedState = state.filter(obj => obj.skill !== skill);
            saveToLocalStorage(updatedState)
            return updatedState;
        }
        default: 
            return state;
    }
}